"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = exports.Checkbox = exports.CheckboxElement = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var react_aria_components_1 = require("react-aria-components");
var icons_1 = require("../../icons");
var theme_1 = require("../../theme");
// Extract color constants
var CHECKBOX_COLORS = {
    border: theme_1.theme.colors.n200,
    borderPressed: theme_1.theme.colors.blue600,
    borderSelected: theme_1.theme.colors.actionPrimary,
    borderSelectedPressed: theme_1.theme.colors.actionPrimaryHovered,
    borderInvalid: theme_1.theme.colors.red500,
    borderInvalidPressed: theme_1.theme.colors.red600,
    backgroundSelected: theme_1.theme.colors.actionPrimary,
    backgroundSelectedPressed: theme_1.theme.colors.actionPrimaryHovered,
    backgroundInvalid: theme_1.theme.colors.red500,
    backgroundInvalidPressed: theme_1.theme.colors.red600,
};
// Helper functions for each state
var getBorderColor = function (_a) {
    var isPressed = _a.isPressed, isSelected = _a.isSelected, isIndeterminate = _a.isIndeterminate, isInvalid = _a.isInvalid;
    if (isInvalid) {
        return isPressed
            ? CHECKBOX_COLORS.borderInvalidPressed
            : CHECKBOX_COLORS.borderInvalid;
    }
    if (isSelected || isIndeterminate) {
        return isPressed
            ? CHECKBOX_COLORS.borderSelectedPressed
            : CHECKBOX_COLORS.borderSelected;
    }
    return isPressed ? CHECKBOX_COLORS.borderPressed : CHECKBOX_COLORS.border;
};
var getBackgroundColor = function (_a) {
    var isPressed = _a.isPressed, isSelected = _a.isSelected, isIndeterminate = _a.isIndeterminate, isInvalid = _a.isInvalid;
    if (isInvalid && (isSelected || isIndeterminate)) {
        return isPressed
            ? CHECKBOX_COLORS.backgroundInvalidPressed
            : CHECKBOX_COLORS.backgroundInvalid;
    }
    if (isSelected || isIndeterminate) {
        return isPressed
            ? CHECKBOX_COLORS.backgroundSelectedPressed
            : CHECKBOX_COLORS.backgroundSelected;
    }
    return 'transparent';
};
var getFocusStyles = function (_a) {
    var isFocusVisible = _a.isFocusVisible;
    return isFocusVisible
        ? (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        outline: ", " solid ", ";\n        outline-offset: ", ";\n      "], ["\n        outline: ", " solid ", ";\n        outline-offset: ", ";\n      "])), theme_1.theme.borderWidths.thick, theme_1.theme.colors.blue400, theme_1.theme.space.space2) : (0, core_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
};
var StyledCheckboxElement = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  border: ", " solid ", ";\n  border-radius: ", ";\n  background: ", ";\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  border: ", " solid ", ";\n  border-radius: ", ";\n  background: ", ";\n  ", "\n"])), theme_1.theme.space.space20, theme_1.theme.space.space20, theme_1.theme.borderWidths.regular, getBorderColor, theme_1.theme.radii.rounded, getBackgroundColor, getFocusStyles);
var CheckboxElement = function (props) { return (react_1.default.createElement(StyledCheckboxElement, __assign({}, props),
    props.isSelected && react_1.default.createElement(icons_1.CheckIcon, { size: 18, color: "contentInverse" }),
    props.isIndeterminate && react_1.default.createElement(icons_1.MinusIcon, { size: 18, color: "contentInverse" }))); };
exports.CheckboxElement = CheckboxElement;
var StyledCheckbox = (0, styled_1.default)(react_aria_components_1.Checkbox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  font-size: ", ";\n\n  &[data-disabled] {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  font-size: ", ";\n\n  &[data-disabled] {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n"])), theme_1.theme.space.space12, theme_1.theme.fontSizes.fontsize16, theme_1.theme.opacity.semiOpaque);
/**
 * A checkbox allows a user to select multiple items from a list of individual items, or to mark one individual item as selected.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Checkbox.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-checkbox--default}
 *
 * @example
 * ```tsx
 * <Checkbox value="terms">I accept the terms and conditions</Checkbox>
 * ```
 *
 * @param value - The value of the checkbox
 * @param isSelected - Whether the checkbox is selected
 * @param isIndeterminate - Whether the checkbox is in an indeterminate state
 * @param isDisabled - Whether the checkbox is disabled
 * @param isReadOnly - Whether the checkbox is read only
 * @param isRequired - Whether the checkbox is required
 * @param children - The content to display next to the checkbox
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
var Checkbox = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(StyledCheckbox, __assign({}, rest), function (_a) {
        var isSelected = _a.isSelected, isIndeterminate = _a.isIndeterminate, isInvalid = _a.isInvalid, isFocusVisible = _a.isFocusVisible, isPressed = _a.isPressed;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.CheckboxElement, { "aria-hidden": "true", isSelected: isSelected, isIndeterminate: isIndeterminate, isInvalid: isInvalid, isFocusVisible: isFocusVisible, isPressed: isPressed }),
            children));
    }));
};
exports.Checkbox = Checkbox;
/**
 * A checkbox group allows a user to select multiple items from a list of options.
 * A checkbox group consists of a set of checkboxes, and a label. Each checkbox includes a label and a visual selection indicator.
 * Zero or more checkboxes within the group can be selected at a time.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/CheckboxGroup.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-checkboxgroup--default}
 *
 * @example
 * ```tsx
 * <CheckboxGroup>
 *   <Checkbox value="dogs">Dogs</Checkbox>
 *   <Checkbox value="cats">Cats</Checkbox>
 *   <Checkbox value="fish">Fish</Checkbox>
 * </CheckboxGroup>
 * ```
 *
 * @param value - The currently selected values
 * @param defaultValue - The default selected values
 * @param isDisabled - Whether the checkbox group is disabled
 * @param isReadOnly - Whether the checkbox group is read only
 * @param isRequired - Whether the checkbox group is required
 * @param orientation - The orientation of the checkbox group
 * @param children - The checkboxes to display in the group
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.CheckboxGroup = (0, styled_1.default)(react_aria_components_1.CheckboxGroup)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  &[data-orientation='horizontal'] {\n    flex-direction: row;\n    align-items: center;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  &[data-orientation='horizontal'] {\n    flex-direction: row;\n    align-items: center;\n  }\n"])), theme_1.theme.space.space8);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CheckboxGroup.js.map